const timeZoneMapping: Record<string, string> = {
  // Pacific Time Zone
  PST: 'America/Los_Angeles', // Pacific Standard Time (UTC-8)

  // Mountain Time Zone
  MT: 'America/Denver', // Mountain Time (UTC-7/-6, observes DST)
  MST_AZ: 'America/Phoenix', // Arizona (does not observe daylight saving time)

  // Central Time Zone
  CST: 'America/Chicago', // Central Standard Time (UTC-6)

  // Eastern Time Zone
  EST: 'America/New_York', // Eastern Standard Time (UTC-5)

  // Alaska Time Zone
  AKT: 'America/Anchorage', // Alaska Standard Time (UTC-9)

  // Hawaii-Aleutian Time Zone
  HST: 'Pacific/Honolulu', // Hawaii Standard Time (UTC-10) (No DST)

  // Atlantic Time Zone (Puerto Rico, US Virgin Islands)
  AST: 'America/Puerto_Rico', // Atlantic Standard Time (UTC-4)

  // Samoa Time Zone
  SST: 'Pacific/Pago_Pago', // Samoa Standard Time (UTC-11)

  // Chamorro Time Zone (Guam, Northern Mariana Islands)
  ChST: 'Pacific/Guam', // Chamorro Standard Time (UTC+10)
};

export const timeZoneOptions = Object.keys(timeZoneMapping);
